<section class="org-card" *ngIf="organization">
    <header class="org-card__header">
        <mat-checkbox
                *ngIf="showCheckboxes"
                class="org-card__select-all"
                color="primary"
                [checked]="allSelected"
                [indeterminate]="someSelected"
                [disabled]="selectableCount === 0"
                [matTooltip]="allSelected ? 'Deselect every location' : 'Select every location'"
                (change)="toggleAll($event.checked)">
        </mat-checkbox>

        <div class="org-card__identity">
            <h3 class="org-card__name">{{ organization.name }}</h3>
            <p class="org-card__meta">
                {{ rows.length }} location{{ rows.length === 1 ? '' : 's' }}<ng-container *ngIf="selectedCount > 0">
                &nbsp;·&nbsp;<span class="org-card__meta-strong">{{ selectedCount }} selected</span></ng-container>
            </p>
        </div>
    </header>

    <ul class="org-card__list">
        <li
                class="org-row"
                *ngFor="let row of rows; trackBy: trackByLocationId"
                [class.is-selected]="row.location.isSelected"
                [class.is-disabled]="row.disabled">
            <mat-checkbox
                    *ngIf="showCheckboxes"
                    class="org-row__check"
                    color="primary"
                    [checked]="!!row.location.isSelected"
                    [disabled]="row.disabled"
                    (change)="toggleLocation(row, $event.checked)">
                <span class="org-row__label">
                    <span class="org-row__name">
                        {{ row.location.name }}
                        <span class="org-row__badge" *ngIf="row.disabled">{{ row.disabledReason }}</span>
                    </span>
                    <span class="org-row__users" *ngIf="row.usernames.length > 0">
                        <mat-icon>person_search</mat-icon>
                        <span class="org-row__user" *ngFor="let username of row.usernames">{{ username }}</span>
                        <span class="org-row__user org-row__user--more" *ngIf="row.extraUsernames > 0">
                            +{{ row.extraUsernames }} more
                        </span>
                    </span>
                </span>
            </mat-checkbox>

            <button
                    type="button"
                    class="org-row__plain"
                    *ngIf="!showCheckboxes"
                    [disabled]="row.disabled"
                    (click)="toggleLocation(row, !row.location.isSelected)">
                {{ row.location.name }}
                <span class="org-row__badge" *ngIf="row.disabled">{{ row.disabledReason }}</span>
            </button>
        </li>

        <li class="org-card__empty" *ngIf="rows.length === 0">No locations in this organization.</li>
    </ul>
</section>
